import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Api } from '@core/api/Api';

@Injectable({
  providedIn: 'root',
})
export class ClarificationService {
  private readonly http = inject(HttpClient);

  loadClarificationJobs() {
    return this.http.get(Api.Clarification);
  }
}
